import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import './ImplementedProjectsSection.css';

// Загрузка картинок для Webpack
function importAll(r) {
    return r.keys().map(r);
}
  
// Динамический импорт всех изображений из папки projects
const projectImages = importAll(require.context('../images/projects', false, /\.(png|jpe?g|svg)$/));

const ImplementedProjectsSection = () => {
    // Генерация данных о проектах на основе массива изображений
    const projects = projectImages.map((image, index) => ({
        id: index + 1,
        image: image,
        title: `Проект ${index + 1}`
    }));
    // Состояние для управления слайдером
    const [currentIndex, setCurrentIndex] = useState(0);
    const [projectsPerView, setProjectsPerView] = useState(4); // Количество проектов, видимых одновременно
    const totalProjects = projects.length;

    // Определение количества отображаемых проектов в зависимости от ширины экрана
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setProjectsPerView(1); // Телефоны
            } else if (window.innerWidth < 992) {
                setProjectsPerView(2); // Планшеты
            } else {
                setProjectsPerView(4); // ПК
            }
        };

        // Инициализация при первой загрузке
        handleResize();

        // Обработчик изменения размера окна
        window.addEventListener('resize', handleResize);

        // Очистка обработчика при размонтировании компонента
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Функции для навигации - с корректной логикой для бесконечной карусели
    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % totalProjects);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + totalProjects) % totalProjects);
    };

     // Генерация элементов карусели с уникальными ключами
    const getSliderItems = () => {
        const items = [];
        for (let i = 0; i < totalProjects + projectsPerView; i++) {
            const index = i % totalProjects;
            items.push({...projects[index], key: `project-${index}-${i}`});
        }
        return items;
    };

    const sliderItems = getSliderItems();

    return (
        <section className="implemented-projects-section py-5">
            <Container>
                {/* Заголовок */}
                <Row className="mb-2">
                    <Col className="text-md-start text-center">
                        <h2 className="section-title">Реализованные проекты</h2>
                        <div className="blue-underline mx-md-0 mx-auto"></div>
                    </Col>
                </Row>
                {/* Описание */}
                <Row className="mb-4">
                    <Col className="section-description">
                        <p className="text-secondary">
                            В рамках реализации Федеральной программы «Доступная Среда» было{' '}
                            <span className="text-primary fw-bold">комплексно оборудовано более 100</span> учреждений
                        </p>
                    </Col>
                </Row>
                
                <Row className="mb-4">
                    {/* Кнопка "Все проекты" */}
                    <Col md={8}>
                        <Link to="/about" className="text-decoration-none">
                            <Button variant="outline-warning" className="rounded-pill all-projects-btn px-4 py-2">
                                Все проекты
                            </Button>
                        </Link>
                    </Col>
                    {/* Кнопки навигации - десктоп */}
                    <Col md={4} className="text-end d-none d-md-block">
                        <div className="navigation-buttons">
                            <Button 
                                variant="outline-secondary" 
                                className="nav-btn me-2"
                                onClick={prevSlide}
                                aria-label="Предыдущий слайд"
                            >
                                <FiArrowLeft />
                            </Button>
                            <Button 
                                variant="outline-secondary" 
                                className="nav-btn"
                                onClick={nextSlide}
                                aria-label="Следующий слайд"
                            >
                                <FiArrowRight />
                            </Button>
                        </div>
                    </Col>
                </Row>
                
                {/* Бесконечный слайдер проектов */}
                <div className="projects-slider-container">
                    <div 
                        className="projects-slider" 
                        style={{
                            transform: `translateX(-${(currentIndex * 100) / projectsPerView}%)`,
                            gridTemplateColumns: `repeat(${sliderItems.length}, ${100 / projectsPerView}%)`,
                            transition: 'transform 0.5s ease'
                        }}
                    >
                        {sliderItems.map((project) => (
                            <div key={project.key} className="project-item-wrapper">
                                <div className="project-item">
                                    <img 
                                        src={project.image} 
                                        alt={project.title} 
                                        className="project-image img-fluid" 
                                        draggable="false"
                                        onDragStart={(e) => e.preventDefault()}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                
                {/* Мобильная навигация */}
                <Row className="mt-3 d-md-none">
                    <Col className="text-center">
                        <div className="navigation-buttons">
                            <Button 
                                variant="outline-secondary" 
                                className="nav-btn me-2"
                                onClick={prevSlide}
                                aria-label="Предыдущий слайд"
                            >
                                <FiArrowLeft />
                            </Button>
                            <Button 
                                variant="outline-secondary" 
                                className="nav-btn"
                                onClick={nextSlide}
                                aria-label="Следующий слайд"
                            >
                                <FiArrowRight />
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ImplementedProjectsSection;